import { deleteApi, getApi, postApi, putApi } from "./apiService";

export const addplan = async (merchantDetails) => {
    return await postApi("/mp/plans/add-plan", merchantDetails);
}

export const getPlan = async () => {
    return await getApi("/mp/plans/get-all-plans")
}

export const getPlanbyId = async (id) => {
    return await getApi(`/mp/plans/get-plan/${id}`)
}

export const updatePlan = async (id, updatedData) => {
    return await putApi(`/mp/plans/update-plan/${id}`, updatedData)
}

export const deletePlan = async (id) => {
    return await deleteApi(`/mp/plans/delete-plan/${id}`)
}

export const getSubscribers = async (queryParams = {}) => {
    const queryString = new URLSearchParams(queryParams).toString();
    return await getApi(`mp/subscription/group/subscribers?${queryString}`);
};

export const getSubscriptionAnalytics = async (queryParams = {}) => {
    const queryString = new URLSearchParams(queryParams).toString();
    return await getApi(`mp/subscription/analytics/subscribers?${queryString}`);
};
